import News       from './components/News';
import NewsDetail from './components/NewsDetail';

export const news = {
  firstLevel:  News,
  secondLevel: NewsDetail,
};